import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import {
  SR_API_ACTION_FINANCES_CREATE_DEPOSIT,
} from 'api/actionTypes';
import {
  PAYMENT_RECEIVED_TYPE_OPTION_ITEMS,
} from 'common/financeConstants';
import {
  createInitialValues,
  createFormValidationFn,
} from 'client/helpers/formikHelpers';
import log from 'client/lib/log';
import withApiState from 'client/helpers/withApiState';
import postWithState from 'client/actions/postWithState';
import branch from 'client/core/branch';

import ButtonDeprecated, {
  BUTTON_THEME_YELLOW,
} from 'client/components/ButtonDeprecated';
import SrFormikField from 'client/components/SrFormikField';

const paymentReceivedFormFields = [
  {
    id: 'checkNumber',
    title: 'Check Number',
    type: 'short_text',
    properties: {
      placeholder: 'XXXX XXXX',
    },
    validations: ['required'],
  },
  {
    id: 'type',
    title: 'Type',
    type: 'select',
    properties: {
      choices: PAYMENT_RECEIVED_TYPE_OPTION_ITEMS,
    },
    validations: ['required'],
  },
  {
    id: 'invoicesToPay',
    title: 'Number of invoices',
    type: 'number',
    properties: {
      placeholder: '1',
    },
    validations: ['required'],
  },
];

function getInvoicesFormFields({ invoicesToPay }) {
  const invociesFormFields = [];

  for (let invoiceNumber = 0; invoiceNumber < invoicesToPay; invoiceNumber += 1) {
    invociesFormFields.push({
      id: `invoices[${invoiceNumber}].quickbooksInvoiceId`,
      title: `QuickBooks ID - ${invoiceNumber + 1}`,
      type: 'number',
      properties: {
        placeholder: 'XXX',
      },
      validations: ['required'],
    });
    invociesFormFields.push({
      id: `invoices[${invoiceNumber}].amount`,
      title: 'Amount',
      type: 'currency',
      properties: {
        placeholder: '$2,000',
      },
      validations: ['required'],
    });
  }

  return invociesFormFields;
}

function getInitialFormValues() {
  const initialFormValues = createInitialValues({
    formFields: [
      ...paymentReceivedFormFields,
      ...getInvoicesFormFields({ invoicesToPay: 10 }),
    ],
  });

  return initialFormValues;
}

@withApiState({
  createDepositApiState: {
    action: SR_API_ACTION_FINANCES_CREATE_DEPOSIT,
  },
})
@branch()
class SrCreateDepositForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    createDepositApiState: PropTypes.object.isRequired,
    onDepositCreated: PropTypes.func.isRequired,
  }

  _onSubmitForm = (values) => {
    const { dispatch, onDepositCreated } = this.props;

    const payload = { ...values };
    payload.invoices = payload.invoices.slice(0, values.invoicesToPay);
    payload.amount = payload.invoices.reduce((sum, invoice) => sum + invoice.amount, 0);

    dispatch(postWithState, {
      action: SR_API_ACTION_FINANCES_CREATE_DEPOSIT,
      payload: payload,
    })
      .then((paymentReceived) => {
        if (onDepositCreated) {
          return onDepositCreated(paymentReceived);
        }
      })
      .catch(log.error);
  }

  render() {
    const {
      createDepositApiState,
    } = this.props;

    return (
      <div className='SrCreateDepositForm'>
        {createDepositApiState.error && (
          <div className='formMessage error'>
            <span>{createDepositApiState.error.message}</span>
          </div>
        )}

        <Formik
          enableReinitialize
          initialValues={getInitialFormValues()}
          validate={(values) => {
            const formFields = [
              ...paymentReceivedFormFields,
              ...getInvoicesFormFields({ invoicesToPay: values.invoicesToPay }),
            ];
            return createFormValidationFn(formFields)(values);
          }}
          onSubmit={this._onSubmitForm}
          render={(formikBag) => {
            const invoicesFormFields = getInvoicesFormFields({
              invoicesToPay: formikBag.values.invoicesToPay || 0,
            });

            return (
              <Form>
                <div className='formContent'>
                  <div className='paymentReceivedSection'>
                    {paymentReceivedFormFields.map((formField) => (
                      <SrFormikField
                        key={formField.id}
                        formField={formField}
                        formikBag={formikBag}
                      />
                    ))}
                  </div>
                  <div className='invoicesSection'>
                    {invoicesFormFields.map((formField) => (
                      <SrFormikField
                        key={formField.id}
                        formField={formField}
                        formikBag={formikBag}
                      />
                    ))}
                  </div>
                </div>
                <div className='bottomActionsContainer'>
                  <ButtonDeprecated
                    type='submit'
                    theme={BUTTON_THEME_YELLOW}
                    disabled={!formikBag.isValid}
                    onClick={formikBag.handleSubmit}
                  >
                    {createDepositApiState.inProgress
                      ? 'please wait...'
                      : 'create deposit'
                    }
                  </ButtonDeprecated>
                </div>
              </Form>
            );
          }}
        />
      </div>
    );
  }
}

SrCreateDepositForm.displayName = 'SrCreateDepositForm';

export default SrCreateDepositForm;
